import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 21.998"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10 0a3 3 0 0 0-1.496.4l-7 4-.004.002A3 3 0 0 0 0 6.996v8.002a2.998 2.998 0 0 0 1.5 2.596l.004.002 7 4a3 3 0 0 0 1.482.396l.014.006.014-.006a3 3 0 0 0 1.482-.396l.004-.002 6.996-3.998.004-.002A3 3 0 0 0 20 15V6.996a3 3 0 0 0-1.5-2.594l-.004-.002L11.5.402A3 3 0 0 0 10 0m0 2a1 1 0 0 1 .5.135l.004.002 6.473 3.699-2.485 1.426L7.514 3.27l1.982-1.133.004-.002A1 1 0 0 1 10 2M5.5 4.42l6.984 3.996L10 9.844 3.023 5.836zM2 7.555l7 4.021v8l-6.5-3.715-.004-.002A1 1 0 0 1 2 15zm16 0v7.443a1 1 0 0 1-.5.863L11 19.576v-8z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "package"}) } }